/**
 * File: createImmunizationForm.js
 * Project: educore
 * Created Date: 2019-03-13
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class CreateImmunizationForm {
    // @ngInject
    constructor($scope, $rootScope, localStorageService, $state, MEDICALCONSTANT, authService, $mdDialog) {

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        let schoolId = localStorageService.get('school_id')
        let userId = localStorageService.get('user_id')
        let academicYear = localStorageService.get('academic_year')
        $scope.selectedSubjects = []
        $scope.messageDetails = [];
        var data = {
            question: "wewe"
        }
        $scope.questionObj = {}
        $scope.topicList = [{
            "name": "Objective",
            "description": "objective"
        }, {
            "name": "Descriptive",
            "description": "descriptive"
        }, {
            "name": "Time",
            "description": "time"
        }]

        $scope.showDescription = false
        let immunizationForm

        function fetchQuestions() {
            authService.callAPI(MEDICALCONSTANT.API_GET_QUESTION + schoolId + '/' + academicYear, "GET", {}, (response) => {
                if (response.result && response.result.data && response.result.data.data) {
                    console.log(response.result)
                    if (response.result.data.data.length > 0) {
                        immunizationForm = response.result.data.data[0]
                        $scope.questionDetails = response.result.data.data[0].questions
                    }

                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        }
        fetchQuestions()
        $scope.addQuestion = () => {
            //Validation  
            $scope.errors = {}
            let errrorCount = 0
            if ($scope.questionObj.question == null || $scope.questionObj.question == undefined || $scope.questionObj.question == "") {
                $scope.errors["question"] = "Question is required";
                errrorCount++;
            }
            if ($scope.questionObj.type == null || $scope.questionObj.type == undefined || $scope.questionObj.type == "") {
                $scope.errors["type"] = "Question type is required";
                errrorCount++;
            }
            if (errrorCount === 0) {
                let obj = {
                    question: $scope.questionObj.question ? $scope.questionObj.question : null,
                    type: $scope.questionObj.type ? $scope.questionObj.type : null,
                    school_id: schoolId,
                    user_id: userId,
                    academic_year: academicYear
                }
                authService.callAPI(MEDICALCONSTANT.API_CREATE_QUESTION, "POST", obj, (response) => {
                    if (response.result && response.result.data && response.result.data.data) {
                        toastr.success("Successfully created a Question");
                        fetchQuestions()
                    }
                })
                $scope.questionObj = {}

            }
        }

        $scope.editAndSubmitQuestion = () => {
            if ($scope.questionObj) {
                if ($scope.questionObj._id) {
                    let obj = {
                        question: $scope.questionObj.question ? $scope.questionObj.question : null,
                        type: $scope.questionObj.type ? $scope.questionObj.type : null,
                        _id: $scope.questionObj._id,
                        user_id: userId
                    }
                    $scope.errors = {}
                    authService.callAPI(MEDICALCONSTANT.API_UPDATE_QUESTION, "POST", obj, (response) => {
                        if (response.result && response.result.data && response.result.data.data) {
                            toastr.success("Question updated successfully");
                            console.log(response.result)
                            $scope.isEdit = false
                            $scope.flagForEdit = false
                            fetchQuestions()

                        } else {
                            $mdDialog.show(
                                $mdDialog.alert()
                                .parent(angular.element(document.querySelector('#popupContainer')))
                                .clickOutsideToClose(true)
                                .title('Warning')
                                .textContent('Cannot edit.Question has been sent to users')
                                .ariaLabel('Alert Dialog Demo')
                                .ok('Ok')
                                .targetEvent()
                            );
                        }
                    })
                    $scope.questionObj = {}

                }
            }

        }

        $scope.editQuestion = (index, data) => {
            $scope.isEdit = true
            $scope.errors = {}
            if (data) {
                if (data._id && data.question) {
                    $scope.flagForEdit = true
                    if (!$scope.questionObj) {
                        $scope.questionObj = {}
                    }
                    $scope.questionObj._id = data._id
                    $scope.questionObj.question = data.question
                    $scope.questionObj.type = data.type
                    if (data.type === "descriptive") {
                        $scope.showDescription = true
                    } else {
                        $scope.showDescription = false
                    }
                }
            }
        }

        $scope.cancelEdit = () => {
            $scope.isEdit = false
            $scope.showDescription = false
            $scope.flagForEdit = false
            $scope.questionObj = {}
            $scope.errors = {}
        }

        $scope.deleteQuestion = (index, data) => {
            let questAnswer
            if (immunizationForm && immunizationForm.questions_answers) {
                questAnswer = _.find(immunizationForm.questions_answers, function(obj) {
                    return data._id === obj._id
                })
            }
            if (questAnswer) {
                $mdDialog.show(
                    $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#popupContainer')))
                    .clickOutsideToClose(true)
                    .title('Warning')
                    .textContent('Cannot delete.Question has been sent to users')
                    .ariaLabel('Alert Dialog Demo')
                    .ok('Ok')
                    .targetEvent()
                );
                return false
            } else {
                let confirm = $mdDialog.confirm()
                    .title('Do you want to delete this question?')
                    .clickOutsideToClose(true)
                    .ariaLabel('Confirm delete')
                    .ok('Yes')
                    .cancel('Cancel');
                $mdDialog.show(confirm).then(function() {
                    authService.callAPI(MEDICALCONSTANT.API_DELETE_QUESTION + data._id, "GET", {}, (response) => {
                        if (response.result && response.result.data && response.result.data.data) {
                            toastr.success("Question deleted Successfully");
                            fetchQuestions()
                            $scope.questionObj = {}
                            $scope.showDescription = false
                            $scope.flagForEdit = false

                        }
                    })
                })
            }
        }
        $scope.showDescConsole = () => {
            let type = $scope.questionObj.type
            if (type === "descriptive") {
                $scope.showDescription = true
            } else {
                $scope.showDescription = false
            }
        }

        $scope.goBack = () => {
            $state.go("filterStudents")
        }
    }
}

export default CreateImmunizationForm



// WEBPACK FOOTER //
// ./src/app/medical/controllers/createImmunizationForm.js